export default "__VITE_ASSET__1fT0v3gX__"